import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { designTokens, Typography } from '@platform-ui/design-system';
import { ZuoraLogo } from './Icons';
import { NavigationContext } from './NavigationContext';
import { useOneIdEnvironment } from './hooks/useOneIdEnvironment';
import { GENERIC_VARIANT } from './hooks/useNavigationVariant';
import useLocalStorage from '@rehooks/local-storage';
import { NavigationConfig } from './types';
import { CONFIG_LOCAL_STORAGE_KEY } from './index';
import { convertToBillingUrl } from './utils/getBillingBaseUrl';

interface StyledLogoProps {
  $isDrawerHidden?: boolean;
}

const LeftBarBrandLink = styled.a<StyledLogoProps>`
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 'auto';
`;

const LeftBarGlobalHeader = styled.h4`
  display: flex;
  height: 100%;
  align-items: center;
  margin-left: 8px;
  letter-spacing: 0.1px;
  cursor: default;
  text-transform: capitalize;
`;

export const homepageLinkHrefs = (
  variant: string,
  revenuePrefix: string,
  homePageUrl?: string,
) => {
  switch (variant) {
    case 'revenue':
      return `${revenuePrefix}/#/dashboard/initialDashboard`;
    case GENERIC_VARIANT:
      return homePageUrl || '/';
    default:
      return convertToBillingUrl('/platform/webapp');
  }
};

export const HomepageLink = () => {
  const { variant } = useContext(NavigationContext);
  const { revenuePrefix } = useOneIdEnvironment();
  const [navConfig] = useLocalStorage<NavigationConfig>(
    CONFIG_LOCAL_STORAGE_KEY,
  );
  let appName: string = variant;
  if (variant === GENERIC_VARIANT) {
    appName = navConfig?.appName || '';
  }
  return (
    <>
      <LeftBarBrandLink
        href={homepageLinkHrefs(variant, revenuePrefix, navConfig?.homePageUrl)}
      >
        <ZuoraLogo />
      </LeftBarBrandLink>
      <LeftBarGlobalHeader>
        <Typography
          variant="subtitle2"
          color={designTokens.colors.darkEmphasisMedium}
        >
          {appName}
        </Typography>
      </LeftBarGlobalHeader>
    </>
  );
};
